import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
} from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { AsyncPipe } from '@angular/common';

import { Block, BlockService, generateSliderConfig, SwiperDirective } from '@speedy/core';

import { BlocksGridComponent } from '../../../shared/components/blocks-grid/blocks-grid.component';
import { ProductsSliderComponent } from '../../../shared/components/products-slider/products-slider.component';
import { homePageSliderConfig } from './home-page-slider-config';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  standalone: true,
  imports: [ProductsSliderComponent, BlocksGridComponent, SwiperDirective, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomePageComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly blockService = inject(BlockService);

  readonly blockIdentifiers = ['home_page_block_1', 'home_page_block_2'];
  readonly homePageSlider1Config = generateSliderConfig('home-page-first');
  readonly homePageSlider2Config = generateSliderConfig('home-page-second');

  readonly productsForHomeCategory$ = this.route.data.pipe(
    filter((data) => data?.home),
    map((data) => data.home.layeredFirst),
  );

  readonly productsForHomeCategory_2$ = this.route.data.pipe(
    filter((data) => data?.home),
    map((data) => data.home?.layeredSecond),
  );

  readonly homePageBannerSlides$: Observable<Block[]> =
    this.blockService.requestBlocksByIdentifier(['home_big_banner_*']);

  homePageSliderConfig = homePageSliderConfig;
}
